import React from "react";
import { connect } from "react-redux";
import SendDataToVifto from "./vifto/SendDataToVifto";
import SendDataToXero from "./xero/SendDataToXero";
import SendDataToQuickbooks from "./quickbooks/SendDataToQuickbooks";
import SendDataToPeoplesPension from "./peoplePension/SendDataToPeoplesPension";
import { useMemo } from "react";
import SendDataToSmartPension from "./smartPension/SendDataToSmartPension";
import FPSSubmissionStatus from "./HMRC/FPSSubmissionStatus";
import { camelCase } from "lodash";
import PensionIntegrationSendData from "./pensionIntegrations/PensionIntegrationSendData";
import AccountingIntegrationSendData from "./accountingIntegrations/AccountingIntegrationSendData";
import PayWith from "./paymentIntegrations/PayWith";

const hasPayrollData = ["Vifto", "Xero", "Quickbooks", "People's Pension", "Smart Pension"];

const IntegrationSendPayrollData = ({ jurisdiction, integrations, userPermissions, period, periodId, style }) => {
	const [integrationList, integrationAmount] = useMemo(() => {
		const integrationAmount = (() => {
			if (["UK"].includes(jurisdiction)) return integrations?.length + 1;
			return integrations?.length;
		})();
		return [integrations, integrationAmount || 0];
	}, [JSON.stringify(integrations)]);

	if (!periodId) return null;
	if (userPermissions == "Read") return null;

	console.log('integrationList',integrationList)

	return (
		<div style={{ display: "flex", ...style }}>
			{integrationList?.map(({ name: integration, section }) => {
				switch (integration) {
					case "Vifto":
						return (
							<SendDataToVifto
								periodId={periodId}
								sentToAccountingIntegration={period?.sentToAccountingIntegration}
							/>
						);
					case "Xero":
						return <SendDataToXero periodId={periodId} />;
					case "Quickbooks":
						return <SendDataToQuickbooks periodId={periodId} />;
					case "People's Pension":
						return <SendDataToPeoplesPension periodId={periodId} />;
					case "Smart Pension":
						return <SendDataToSmartPension periodId={periodId} />;
					default:
						switch (section) {
							case "accounting":
								return (
									<AccountingIntegrationSendData
										periodId={periodId}
										integration={integration}
									/>
								);
							case "pension":
								return (
									<PensionIntegrationSendData
										periodId={periodId}
										integration={integration}
									/>
								);
							case "payment":
								return (
									<PayWith
										integration={integration}
										periodId={periodId}
										period={period}
									/>
								);
							default:
								return null;
						}
				}
			})}
			<FPSSubmissionStatus period={period} />
		</div>
	);
};

const mapStateToProps = (state) => {
	const integrations = Object.entries(state.integration || {})?.reduce((prev, [section, curr]) => {
		Object.values(curr || {})?.map((item) => {
			const { functionality } = state.integrationDetails?.[section]?.[camelCase(item.name)] || {};

			if (hasPayrollData.includes(item.name) || functionality?.payroll?.send) {
				prev.push({ name: item.name, section });
			}
		});
		return prev;
	}, []);
	return {
		jurisdiction: state.company?.settings?.jurisdiction,
		integrations,
		userPermissions: state?.permissions?.my?.permissions?.timesheets,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationSendPayrollData);
